import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    // q6: '{q5} anyof [0]',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q0} = 1) or ({q1} = 1) or ({q2} = 0 or {q2} = 1)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  // 初學探險者
  const IMG_BEGINNER = 'https://i.postimg.cc/Y2XYFhqn/9-0.png'
  // 抗氧化勇者
  const IMG_HERO = 'https://i.postimg.cc/cHB72hWJ/7-0.png'
  // 健康守護者
  const IMG_GUARDIAN = 'https://i.postimg.cc/pdNDd4V6/8-0.png'

  // 結尾訊息的工具函式（統一樣式）
  function buildEndMessage({ img, title, subtitle, body, alt }) {
    return `
  <div style="text-align:center;padding:12px;white-space:normal;">
    <img 
      src="${img}" 
      alt="${alt || title}" 
      style="max-width:100%;width:400px;height:auto;object-fit:contain;display:inline-block;"
    >
    <div style="max-width:520px;margin:16px auto 0;text-align:left;line-height:1.7;font-size:16px;color:#222;">
      <div style="font-size:22px;font-weight:700;line-height:1.3;margin-bottom:6px;">${title}</div>
      <div style="font-size:16px;color:#666;margin-bottom:12px;">${subtitle}</div>
      <div style="white-space:pre-wrap;">${body}</div>
    </div>
  </div>`
  }

  // 三個等級的 HTML 內容
  // 抗氧化勇者
  const endMessageHero = buildEndMessage({
    img: IMG_HERO,
    title: '抗氧化勇者',
    subtitle: '飲食與觀念兼具，維持高抗氧化力',
    body: '你對健康有明確的意識與行動力！不僅懂得自由基對身體的影響，也能透過日常飲食或保健習慣有效對抗它。你知道「吃對」比「吃多」更重要，會主動選擇深色蔬菜、堅果、莓果與茶類來補充抗氧化營養。你是身邊朋友眼中的健康指標，用實際行動守護自己，也啟發他人。持續保持這樣的生活習慣，未來的你依然會閃閃發亮，像維他命一樣照亮別人！',
    alt: '抗氧化勇者',
  })

  // 健康守護者
  const endMessageGuardian = buildEndMessage({
    img: IMG_GUARDIAN,
    title: '健康守護者',
    subtitle: '已具健康概念，持續行動更完美',
    body: '你對健康有相當的認知，也願意為身體多做一點。雖然偶爾會忙碌到忽略飲食平衡，但你知道什麼是對的方向，並努力讓生活習慣更穩定。你或許已開始補充維生素、偶爾選擇茶或蔬果，但距離「抗氧化勇者」只差一點持續力。試著多讓健康成為日常的一部分——在早餐多加幾片水果、或晚餐多一份蔬菜——這些小小改變，會讓你的抗氧化力越來越強大！',
    alt: '健康守護者',
  })

  // 初學探險者
  const endMessageBeginner = buildEndMessage({
    img: IMG_BEGINNER,
    title: '初學探險者',
    subtitle: '剛起步的健康新手，從彩虹蔬果開始',
    body: '你對抗氧化還不太熟悉，但願意了解、開始行動，這就是最好的起點。或許你不常吃蔬果，也不確定哪些食物能幫助身體抵禦自由基，不過別擔心——每個健康達人都從「不知道」開始。從現在起，試著在餐桌上加點顏色吧！橘紅的胡蘿蔔、綠油油的菠菜、紫色的莓果，都是讓身體更有能量的好夥伴。你正在探索屬於自己的健康節奏，一步步前進，也是一種成長。',
    alt: '初學探險者',
  })

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q2)', survey.getValue('q2'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (
      survey.getValue('q6') === 1 &&
      survey.getValue('q5') === 1 &&
      (survey.getValue('q2') === 0 || survey.getValue('q2') === 1)
    ) {
      // 抗氧化勇者
      setCompletionMessage(endMessageHero)
    } else if (
      (survey.getValue('q5') === 0 || survey.getValue('q5') === 2) &&
      (survey.getValue('q6') === 0 || survey.getValue('q6') === 2)
    ) {
      // 初學探險者
      setCompletionMessage(endMessageBeginner)
    } else {
      // 健康守護者
      setCompletionMessage(endMessageGuardian)
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
